<template>
  <li
    v-if="canViewHorizontalNavMenuHeaderLink(item)"
    class="nav-item horizontal-nav-menu-header-link"
    :class="{'sidebar-group-active active': isActive}"
  >
    <b-link
      class="nav-link px-75 horizontal-nav-menu-header-link__link"
      :to="{ name: item.route }"
    >
      <div class="d-flex align-items-center">
        <font-awesome-icon v-if="item.icon" :icon="item.icon" class="horizontal-nav-menu-header-link__icon font-medium-1" />
        <span>{{ t(item.title) }}</span>
      </div>
    </b-link>
  </li>
</template>

<script>
import { BLink } from 'bootstrap-vue'
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import { useUtils as useAclUtils } from '@core/libs/acl'
import useHorizontalNavMenuHeaderLink from './useHorizontalNavMenuHeaderLink'
import mixinHorizontalNavMenuHeaderLink from './mixinHorizontalNavMenuHeaderLink'

export default {
  components: {
    BLink,
  },
  mixins: [mixinHorizontalNavMenuHeaderLink],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { isActive, updateIsActive } = useHorizontalNavMenuHeaderLink(props.item)

    const { t } = useI18nUtils()
    const { canViewHorizontalNavMenuHeaderLink } = useAclUtils()

    return {
      isActive,
      updateIsActive,

      // ACL
      canViewHorizontalNavMenuHeaderLink,

      // i18n
      t,
    }
  },
}
</script>
<style scoped lang="scss">
@import '@/assets/scss/variables/_variables-components.scss';
.horizontal-nav-menu-header-link {
  font-size: 12px;
  &.active {
    .horizontal-nav-menu-header-link__link {
      .horizontal-nav-menu-header-link__icon {
        color: #e4e6eb !important;
      }
    }
  }
  &:not(.active) {
    .horizontal-nav-menu-header-link__link {
      .horizontal-nav-menu-header-link__icon {
        color: $theme-dark-headings-color;
      }
    }
  }
}
</style>